import React from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { quantityChange } from "../../../api/orderApi";

class OrderDetailTable extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor() {
        super();

        this.getColumns = this.getColumns.bind(this);

        this.reactTable = React.createRef();
    }

    getColumns = () => {
        const {
            isOrderSubmitted,
            serviceId
        } = this.props;

        let result = [];

        result.push({
            Header: "Item Code",
            accessor: "itemCode",
            id: "itemCode"
        });
        result.push({
            Header: "Slot Code",
            accessor: "slotNumber",
            id: "slotCode"
        });
        result.push({
            Header: "UPC",
            accessor: "upc",
            id: "upc"
        });
        result.push({
            Header: "Title",
            accessor: "title",
            id: "title"
        });
        result.push({
            Header: "Qty",
            accessor: "quantity",
            id: "quantity",
            Cell: ({ original }) => (
                isOrderSubmitted ?
                    original.quantity :
                    <input
                        type="number"
                        min={0}
                        defaultValue={original.quantity}
                        onBlur={(e) =>
                            quantityChange(original.orderDetailId,
                                serviceId, parseInt(e.target.value, 10))}
                        className="form-control"
                    />
            ),
        });
        result.push({
            Header: "Retail",
            accessor: "retail",
            id: "retail",
            Cell: ({ original }) => (
                <div className="mr-1">
                    {`$ ${original.retail}`}
                </div>
            )
        });

        result = result.map((value) => {
            value.headerClassName = "text-left";
            if (!value.style) {
                value.style = {};
            }
            if (value.style) {
                value.style.display = "flex";
                value.style.alignItems = "center";
                value.style.height = "100%";
            }

            return value;
        });

        return result;
    };

    render() {
        const {
            loading,
            orderDetails
        } = this.props;

        return (

            <ReactTable
                data={orderDetails}
                headerClassName="table-header"
                columns={this.getColumns()}
                resizable
                className="-striped -highlight fix-scrollbar-size"
                loading={loading}
                ref={this.reactTable}
                filterable={false}
                showPagination={false}
                style={{
                    height: "calc(100vh - 350px)"
                }}
                getNoDataProps={() => ({
                    style: {
                        zIndex: 0
                    }
                })}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(OrderDetailTable);
